// Meta (Facebook) Pixel helper
// Loads fbevents.js once, initializes the pixel, and exposes typed track helpers.

const PIXEL_ID = '1693254688276508'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Loads the Meta Pixel base code (idempotent) and initializes the pixel.
 * Safe to call multiple times — the underlying script loads only once.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (initialized && window.fbq) return /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      // Preview/build environments may have no <script> tag in the DOM yet.
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq('init', PIXEL_ID)
  initialized = true
}

/** Fires the standard PageView event. */
export function trackPageView(): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

/**
 * Fires the standard AddToCart event.
 * Call this on CTA clicks just before navigating to checkout.
 */
export function trackAddToCart(params?: {
  value?: number
  currency?: string
  content_name?: string
}): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', {
    content_name: params?.content_name ?? 'Libre de Endodolor — Plan 21 días',
    value: params?.value ?? 6.36,
    currency: params?.currency ?? 'USD',
  })
}
